"use strict";

import { gsap } from "gsap";
import main from "../css/sass/main.scss";
import inline from "../css/sass/inline.scss";

import headerScrolling from "./scripts/headerScrolling";
import mobileMenu from "./scripts/mobileMenu";
import megaMenu from "./scripts/megaMenu";
import inputSelect from "./scripts/inputSelect";
import accordion from "./scripts/accordion";
import gsapAnimations from "./scripts/gsapAnimations";
import marcasSlider from "./scripts/slider/marcasSlider";
import paraQuemSlider from "./scripts/slider/paraQuemSlider";
import highlightCardsSlider from "./scripts/slider/highlightCardsSlider";
import blogFilter from "./scripts/blogFilter";
import casesFilter from "./scripts/casesFilter";
import dragScroll from "./scripts/dragScroll";
import anchorScroll from "./scripts/anchorScroll";

window.gsap = gsap;

headerScrolling();
mobileMenu();
megaMenu();
inputSelect();
accordion();
gsapAnimations();
marcasSlider();
paraQuemSlider();
highlightCardsSlider();
blogFilter();
casesFilter();
dragScroll();
anchorScroll();
